import React, { useState, useEffect, useCallback, useContext, useRef } from "react";
// import { useLocation } from "react-router-dom";

import TranslationContext from "../Context/Translation";
import NavigationSwitcher from "../Components/Navigation/NavigationSwitcher";

import { REACT_APP_TOP_NAVIGATION } from "../Constants/APIConstants";
import { getApi } from "../Utils/ApiUtils";

const NavigationContainer = () => {
  const { translation } = useContext(TranslationContext);
  const currentTranslation = useRef(null);

  const [isNavigationLoaded, setNavigationLoaded] = useState(false);
  const [navigation, setNavigation] = useState(false);

  // const location = useLocation();

  const loadNavigation = useCallback(async () => {
    if (!REACT_APP_TOP_NAVIGATION) {
      // eslint-disable-next-line no-console
      console.error(
        "REACT_APP_TOP_NAVIGATION is not defined. Please check your .env.development file.",
      );
      return;
    }

    const activeTranslation = translation.find((lang) => lang.active === 1);

    if (!activeTranslation) {
      // eslint-disable-next-line no-console
      console.warn("NavigationContainer: No active translation found");
      return;
    }

    if (!activeTranslation.link) {
      // eslint-disable-next-line no-console
      console.warn("NavigationContainer: Active translation has no link property");
      return;
    }

    const url =
      activeTranslation.link.split("/")[1]?.length === 2
        ? `/${activeTranslation.link.split("/")[1]}${REACT_APP_TOP_NAVIGATION}`
        : REACT_APP_TOP_NAVIGATION;

    // eslint-disable-next-line no-console
    console.log("NavigationContainer: Loading navigation from:", url);

    try {
      const { data } = await getApi(url);

      if (data?.content?.colPos0?.length) {
        setNavigation(data.content.colPos0[0]);
        setNavigationLoaded(true);
        // eslint-disable-next-line no-console
        console.log("NavigationContainer: Navigation loaded successfully");
      } else {
        // eslint-disable-next-line no-console
        console.warn("NavigationContainer: API response missing content.colPos0");
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("NavigationContainer: Error loading navigation:", error);
      setNavigationLoaded(false);
    }
  }, [translation]);

  useEffect(() => {
    // without this check it will initially fire twice: first time on initial load when
    // translation.length is 0 and second time when translation will be set in Context
    // also we ensure this way that activeTranslation below will not be undefined
    if (translation.length) {
      const activeTranslation = translation.find((lang) => lang.active === 1);

      if (!activeTranslation) {
        return;
      }

      // we need to remember the current translation language after we initially set
      // translations in Context
      if (!currentTranslation.current) {
        currentTranslation.current = activeTranslation;
      }

      // AND after current translation language is changed
      if (currentTranslation.current?.twoLetterIsoCode !== activeTranslation.twoLetterIsoCode) {
        currentTranslation.current = activeTranslation;

        setNavigationLoaded(false);
      }
    }
  }, [translation]);

  useEffect(() => {
    // without second check it will initially fire twice: first time on initial load when
    // translation.length is 0 and second time when translation will be set in Context and
    // isNavigationLoaded will be reset
    // also we ensure that activeTranslation in loadNavigation() will not be undefined
    if (!isNavigationLoaded && translation.length) {
      loadNavigation();
    }
  }, [translation, isNavigationLoaded, loadNavigation]);

  // useEffect(() => {
  //   if (isNavigationLoaded) {
  //     const mainContentElement = document.getElementById("main");

  //     let navigationElement = document.getElementById("navigation").querySelector(".navbar");
  //     let navigationHeight = navigationElement.offsetHeight;

  //     mainContentElement.style.paddingTop = `${navigationHeight}px`;

  //     window.addEventListener("resize", () => {
  //       navigationElement = document.getElementById("navigation").querySelector(".navbar");

  //       navigationHeight = navigationElement.offsetHeight;

  //       mainContentElement.style.paddingTop = `${navigationHeight}px`;
  //     });
  //   }
  // }, [isNavigationLoaded, location.pathname]);

  const renderNavigation = () => {
    if (!isNavigationLoaded) {
      return <></>;
    }

    if (isNavigationLoaded && navigation) {
      const activeLanguage = translation.find((lang) => lang.active === 1);
      return (
        <NavigationSwitcher
          type={navigation.type}
          appearance={navigation.appearance}
          content={navigation.content}
          languages={translation}
          activeLanguage={activeLanguage || translation[0]}
        />
      );
    }

    return <></>;
  };

  return renderNavigation();
};

export default NavigationContainer;
